const initialState = {
  fetching: false,
};

export default function multiTemplateReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'OFFER_FETCHING':
      return { ...currentState, fetching: true };
    case 'LOADING_OFF':
      return { ...currentState, fetching: true };
    case 'OFFER_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
